import { inject, Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { selectIsLoading, selectIsTokenValid } from '../+state/auth.reducer';
import { filter, Observable, switchMap, tap } from 'rxjs';
import { AuthActions } from '../..';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
    private readonly router = inject(Router);
    private readonly store = inject(Store);

    canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.store.select(selectIsTokenValid).pipe(
            tap(valid => {
                if (!valid) {
                    this.store.dispatch(AuthActions.getToken());
                }
                return valid;
            }),
            switchMap(() => this.store.select(selectIsLoading).pipe(filter(loading => !loading))),
            switchMap(() =>
                this.store.select(selectIsTokenValid).pipe(
                    tap(valid => {
                        if (!valid) {
                            this.router.navigate(['/unavailable']);
                        }
                    })
                )
            )
        );
    }
}
